/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_accionProyecto as accionProyecto,
  rec_Cargando as Cargando,
  rec_Componente_LD_76_68 as Componente_LD_76_68,
  rec_Componente_MD_77_68 as Componente_MD_77_68,
  rec_DetalleTarea as DetalleTarea,
  rec_EstadoError as EstadoError,
  rec_Fx as Fx,
  rec_GT as GT,
  rec_HE as HE,
  rec_JSXRuntime as JSXRuntime,
  rec_TarjetaKanban as TarjetaKanban,
  rec_Px as Px,
  rec_Qr as Qr,
  rec_Qw as Qw,
  rec_React as React,
  rec_Ro as Ro,
  rec_SelectorMultiple as SelectorMultiple,
  rec_Ti as Ti,
  rec_Uw as Uw,
  rec_Ww as Ww,
  rec_api as api,
  rec_cD as cD,
  rec_fC as fC,
  rec_ko as ko,
  rec_nw as nw,
  rec_obtenerUsuario as obtenerUsuario,
  rec_qr as qr,
  rec_ri as ri,
  rec_tw as tw,
  rec_usuarioIdSesion as usuarioIdSesion,
  rec_zr as zr,
} from "../../runtime/index.jsx";
export function TableroTareas({ proyecto: e }) {
  let [t, n] = (0, React.useState)([]),
    [r, i] = (0, React.useState)([]),
    [a, o] = (0, React.useState)([]),
    [s, c] = (0, React.useState)([]),
    [l, u] = (0, React.useState)(!0),
    [f, p] = (0, React.useState)(``),
    [m, h] = (0, React.useState)(void 0),
    [g, _] = (0, React.useState)(() => tw(`tablero-vista`, `tablero`)),
    [v, y] = (0, React.useState)(!1),
    [b, x] = (0, React.useState)(null),
    [S, C] = (0, React.useState)({
      asignado: ``,
      prioridad: ``,
      meta: ``,
      etiqueta: ``,
      lista: ``,
      texto: ``,
    }),
    w = !accionProyecto(e, `planner.tareas.crear`) && !accionProyecto(e, `planner.tareas.estado`),
    T = Ww(
      Uw(GT, {
        activationConstraint: {
          distance: 6,
        },
      }),
    ),
    E = (0, React.useCallback)(async () => {
      (u(!0), p(``));
      try {
        let t = new URLSearchParams({
          proyecto: e.id,
        });
        (S.asignado && t.set(`asignado`, S.asignado),
          S.prioridad && t.set(`prioridad`, S.prioridad),
          S.meta && t.set(`meta`, S.meta),
          S.etiqueta && t.set(`etiqueta`, S.etiqueta),
          S.lista && t.set(`lista`, S.lista),
          S.texto.trim() && t.set(`texto`, S.texto.trim()));
        let [r, a, s, l] = await Promise.all([
          api(`/tareas?${t}`),
          api(`/metas?proyecto=${e.id}`),
          api(`/etiquetas?proyecto=${e.id}`),
          api(`/listas?proyecto=${e.id}`),
        ]);
        (n(r),
          i(a),
          o(s),
          c(l),
          Object.values(S).some(Boolean) && ko(`USAR_FILTRO`, `TABLERO`, e.id));
      } catch (e) {
        p(e.message);
      } finally {
        u(!1);
      }
    }, [e.id, S]);
  ((0, React.useEffect)(() => {
    E();
  }, [E]),
    (0, React.useEffect)(
      () =>
        fC(() => E(), {
          proyectoId: e.id,
        }),
      [E, e.id],
    ));
  let D = Object.values(S).some(Boolean);
  function O(e) {
    (_(e), nw(`tablero-vista`, e));
  }
  let k = (0, React.useMemo)(() => {
    let e = {};
    return (
      Px.forEach((t) => (e[t] = [])),
      t.forEach((t) => {
        e[t.estado] && e[t.estado].push(t);
      }),
      Object.values(e).forEach((e) => e.sort((e, t) => e.orden - t.orden)),
      e
    );
  }, [t]);
  function A(e) {
    return Px.includes(e) ? e : (t.find((t) => t.id === e)?.estado ?? null);
  }
  async function j(r) {
    x(null);
    let { active: i, over: a } = r;
    if (!a) return;
    let o = i.id,
      s = A(o),
      c = A(a.id);
    if (!s || !c) return;
    let l = t.find((e) => e.id === o),
      u = usuarioIdSesion(),
      d =
        l &&
        (l.puedoMandar ||
          l.creadoPorUsuarioId === u ||
          (l.asignados ?? []).some((e) => e.usuarioId === u) ||
          e.miRol === `ADMIN`);
    if (l && !d && s !== c) {
      (p(`Esta tarea la maneja quien la encargó y quien la tiene asignada.`),
        E());
      return;
    }
    if (
      l &&
      c === `COMPLETADA` &&
      l.necesitaConforme &&
      (l.asignados ?? []).some((e) => e.usuarioId === u) &&
      l.creadoPorUsuarioId !== u &&
      e.miRol !== `ADMIN`
    ) {
      (p(
        `Para darla por terminada, mandala a "En revisión": la aprueba quien te la encargó.`,
      ),
        E());
      return;
    }
    let f = k[c].map((e) => e.id).filter((e) => e !== o),
      m = Px.includes(a.id) ? f.length : f.indexOf(a.id);
    (f.splice(m < 0 ? f.length : m, 0, o),
      n((e) =>
        e.map((e) =>
          e.id === o
            ? {
                ...e,
                estado: c,
                orden: f.indexOf(e.id),
              }
            : f.includes(e.id)
              ? {
                  ...e,
                  orden: f.indexOf(e.id),
                }
              : e,
        ),
      ));
    try {
      (s !== c &&
        (await api(`/tareas/${o}/mover`, {
          method: `POST`,
          body: JSON.stringify({
            estado: c,
            actorNombre: obtenerUsuario()?.nombre,
          }),
        })),
        await api(`/tareas/reordenar`, {
          method: `POST`,
          body: JSON.stringify({
            proyectoId: e.id,
            ids: f,
          }),
        }));
    } catch (e) {
      (p(e.message), E());
    }
  }
  return l ? (
    <Cargando
      variante={`tarjetas`}
      cantidad={4}
      etiqueta={`Cargando el tablero`}
    />
  ) : (
    <div
      className={`flex flex-col gap-4`}
      children={[
        <div
          className={`flex flex-wrap items-center justify-between gap-2`}
          children={[
            <div
              className={`flex items-center gap-2`}
              children={[
                <div
                  className={`flex overflow-hidden rounded-full border border-(--border)`}
                  children={[
                    <button
                      type={`button`}
                      onClick={() => O(`tablero`)}
                      className={`flex items-center gap-1 px-3 py-1.5 text-xs font-medium transition duration-150 ease-(--curva) ${g === `tablero` ? `bg-(--accent) text-(--accent-fg)` : `text-(--text-h)`}`}
                      children={[<Qr className={`h-3.5 w-3.5`} />, ` Tablero`]}
                    />,
                    <button
                      type={`button`}
                      onClick={() => O(`lista`)}
                      className={`flex items-center gap-1 px-3 py-1.5 text-xs font-medium transition duration-150 ease-(--curva) ${g === `lista` ? `bg-(--accent) text-(--accent-fg)` : `text-(--text-h)`}`}
                      children={[
                        (0, JSXRuntime.jsx)(ri, {
                          className: `h-3.5 w-3.5`,
                        }),
                        ` Lista`,
                      ]}
                    />,
                  ]}
                />,
                <button
                  type={`button`}
                  onClick={() => y((e) => !e)}
                  className={`flex items-center gap-1 rounded-full border px-3 py-1.5 text-xs font-medium ${D ? `border-(--accent) text-(--accent)` : `border-(--border) text-(--text-h)`}`}
                  children={[
                    (0, JSXRuntime.jsx)(qr, {
                      className: `h-3.5 w-3.5`,
                    }),
                    ` Filtros`,
                    D ? ` ·` : ``,
                  ]}
                />,
              ]}
            />,
            <div
              className={`flex items-center gap-2`}
              children={[
                <span
                  className={`text-sm text-(--text)`}
                  children={[t.length, ` tareas`]}
                />,
                !w && (
                  <button
                    type={`button`}
                    onClick={() => h(null)}
                    className={Ro}
                    children={[
                      <Ti className={`mr-1 inline h-4 w-4`} />,
                      ` Nueva tarea`,
                    ]}
                  />
                ),
              ]}
            />,
          ]}
        />,
        v && (
          <div
            className={`animar-entrada grid gap-2 rounded-2xl border border-(--border) bg-(--bg) p-3 sm:grid-cols-3 lg:grid-cols-6`}
            children={[
              <input
                className={`w-full rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm text-(--text-h) outline-none transition duration-150 ease-(--curva) focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg)`}
                placeholder={`Buscar…`}
                value={S.texto}
                onChange={(e) =>
                  C({
                    ...S,
                    texto: e.target.value,
                  })
                }
              />,
              <SelectorMultiple
                value={S.asignado}
                onChange={(e) =>
                  C({
                    ...S,
                    asignado: e,
                  })
                }
                placeholder={`Asignado`}
                opciones={(e.miembros ?? []).map((e) => ({
                  value: String(e.usuarioId),
                  label: e.usuarioNombre || `Usuario ${e.usuarioId}`,
                }))}
              />,
              <SelectorMultiple
                value={S.prioridad}
                onChange={(e) =>
                  C({
                    ...S,
                    prioridad: e,
                  })
                }
                placeholder={`Prioridad`}
                opciones={Fx.map((e) => ({
                  value: e.codigo,
                  label: e.label,
                }))}
              />,
              <SelectorMultiple
                value={S.meta}
                onChange={(e) =>
                  C({
                    ...S,
                    meta: e,
                  })
                }
                placeholder={`Meta`}
                opciones={r.map((e) => ({
                  value: String(e.id),
                  label: e.titulo,
                }))}
              />,
              <SelectorMultiple
                value={S.etiqueta}
                onChange={(e) =>
                  C({
                    ...S,
                    etiqueta: e,
                  })
                }
                placeholder={`Etiqueta`}
                opciones={a.map((e) => ({
                  value: String(e.id),
                  label: e.nombre,
                }))}
              />,
              <div
                className={`flex gap-2`}
                children={[
                  <SelectorMultiple
                    value={S.lista}
                    onChange={(e) =>
                      C({
                        ...S,
                        lista: e,
                      })
                    }
                    placeholder={`Lista`}
                    opciones={s.map((e) => ({
                      value: String(e.id),
                      label: e.nombre,
                    }))}
                  />,
                  D && (
                    <button
                      type={`button`}
                      onClick={() =>
                        C({
                          asignado: ``,
                          prioridad: ``,
                          meta: ``,
                          etiqueta: ``,
                          lista: ``,
                          texto: ``,
                        })
                      }
                      aria-label={`Limpiar filtros`}
                      className={`shrink-0 rounded-full border border-(--border) p-2 text-(--text) hover:bg-(--accent-bg)`}
                      children={(0, JSXRuntime.jsx)(zr, {
                        className: `h-4 w-4`,
                      })}
                    />
                  ),
                ]}
              />,
            ]}
          />
        ),
        <EstadoError mensaje={f} onReintentar={E} />,
        g === `tablero` ? (
          <HE
            sensors={T}
            collisionDetection={Qw}
            onDragStart={(e) => x(t.find((t) => t.id === e.active.id) ?? null)}
            onDragEnd={j}
            onDragCancel={() => x(null)}
            children={[
              <div
                className={`grid gap-3 lg:grid-cols-4`}
                children={Px.map((e) => (
                  <Componente_MD_77_68
                    key={e}
                    id={e}
                    tareas={k[e]}
                    onCard={h}
                    soloLectura={w}
                  />
                ))}
              />,
              (0, JSXRuntime.jsx)(cD, {
                children: b && <TarjetaKanban t={b} arrastrando={!0} />,
              }),
            ]}
          />
        ) : (
          <Componente_LD_76_68 tareas={t} listas={s} onCard={h} />
        ),
        m !== void 0 && (
          <DetalleTarea
            proyecto={e}
            tarea={m}
            metas={r}
            etiquetas={a}
            listas={s}
            tareasProyecto={t}
            onClose={() => h(void 0)}
            onGuardado={E}
          />
        ),
      ]}
    />
  );
}
